import { IRootStoreState } from '@/store/types'
import { IAction } from '@/store/types/action'
import { IActionWithoutPayload } from '@/store/types/action'
import { IParameters } from '@/types/parameters'
import { IUser } from '@/types/user'
import {
  CLOSE_CONFIRM_ROUTE_CHANGE_DIALOG,
  OPEN_CONFIRM_ROUTE_CHANGE_DIALOG,
  SET_ACTION_TO_HANDLE_UNSAVED_WORK,
  SET_APP_LOADED,
  SET_GLOBAL_ERROR,
  SET_PARAMS,
  SET_USER,
  THERE_IS_NOT_UNSAVED_WORK,
  THERE_IS_UNSAVED_WORK,
} from './mutation-types'

const setUser: IAction<IRootStoreState, IUser> = async ({ commit }, user) => {
  commit(SET_USER, user)
}

const setParameters: IAction<IRootStoreState, IParameters | undefined> = async ({ commit }, parameters) => {
  commit(SET_PARAMS, parameters)
}

const setAppIsLoading: IAction<IRootStoreState, boolean> = ({ commit }, isLoaded) => {
  commit(SET_APP_LOADED, isLoaded)
}

const setGlobalError: IAction<IRootStoreState, string | undefined> = ({ commit }, error) => {
  commit(SET_GLOBAL_ERROR, error)
}

const thereIsUnsavedWork: IActionWithoutPayload<IRootStoreState> = ({ commit }) => {
  commit(THERE_IS_UNSAVED_WORK)
}

const thereIsNotUnsavedWork: IActionWithoutPayload<IRootStoreState> = ({ commit }) => {
  commit(THERE_IS_NOT_UNSAVED_WORK)
}

const openConfirmRouteChangeDialog: IAction<IRootStoreState, string> = ({commit}, pathToGoIfModalIsConfirmed) => {
  commit(OPEN_CONFIRM_ROUTE_CHANGE_DIALOG, pathToGoIfModalIsConfirmed)
}

const closeConfirmRouteChangeDialog: IActionWithoutPayload<IRootStoreState> = ({commit}) => {
  commit(CLOSE_CONFIRM_ROUTE_CHANGE_DIALOG)
}
/**
 *
 * @param vuexParams
 *    Standard Vuex action parameters
 * @param actionToHandleUnsavedWork
 *    Function which will be executed before change root.
 *    If this action returns false the route changement will be canceled
 *    This function can be async
 */
const setActionToHandleUnsavedWork: IAction<IRootStoreState, () => boolean> =
({ commit }, actionToHandleUnsavedWork) => {
  commit(SET_ACTION_TO_HANDLE_UNSAVED_WORK, actionToHandleUnsavedWork)
}

export default {
  setUser,
  setParameters,
  setAppIsLoading,
  setGlobalError,
  thereIsUnsavedWork,
  thereIsNotUnsavedWork,
  setActionToHandleUnsavedWork,
  openConfirmRouteChangeDialog,
  closeConfirmRouteChangeDialog,
}
